import { mergeAttributes, Node, wrappingInputRule } from '@tiptap/core';

export interface OrderedListOptions {
    itemTypeName: string;
    HTMLAttributes: Record<string, any>;
    keepMarks: boolean;
    keepAttributes: boolean;
}

export const WordOrderedList = Node.create<OrderedListOptions>({
    name: 'orderedList',
    addOptions() {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {
                class: 'px-4 list-decimal',
            },
            keepMarks: false,
            keepAttributes: true,
        };
    },
    priority: 900,
    group: 'block list',
    content() {
        return `${this.options.itemTypeName}+`;
    },
    addAttributes() {
        return {
            ...this.parent?.(),
            start: {
                default: 1,
                parseHTML: element => {
                    return element.hasAttribute('start') ? parseInt(element.getAttribute('start') || '', 10) : 1;
                },
            },
            listStyleType: {
                default: 'decimal',
                parseHTML: element => {
                    return element.style.listStyleType || 'decimal';
                },
                renderHTML: attributes => {
                    return {
                        ...attributes,
                        style: `list-style-type: ${attributes.listStyleType}`,
                    };
                },
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'ol',
                getAttrs: () => false,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        const { start, ...attributesWithoutStart } = HTMLAttributes;

        return start === 1 ? ['ol', mergeAttributes(this.options.HTMLAttributes, attributesWithoutStart), 0] : ['ol', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
});
